import React, { FunctionComponent, useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from './UserContext';
import { PageContext } from './PageContext';
import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout';
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators"
import { menuIcon } from '@progress/kendo-svg-icons';
import { Button, DropDownButton, SplitButton } from '@progress/kendo-react-buttons';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser, faQuestionCircle, faBell, faMagnifyingGlass, faForward, faFileCirclePlus, faTrash, faShare, faGlobe, faQuestion, faBullhorn} from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {Grid, GridColumn as Column, GridDataStateChangeEvent, GridSortChangeEvent, GridCustomCellProps, GridCellProps, GridCellsSettings} from '@progress/kendo-react-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';

import { getSavedQueries, deleteUserQuery, getNextAd } from '../services/apiService';
import parse from 'html-react-parser';
import { ButtonGroup } from 'reactstrap';
import { Notification } from '@progress/kendo-react-notification';
import { SubmissionForm } from './SubmissionForm';
import { SubmissionContextProvider } from './SubmissionFormContext';
import { SearchFields, atolUser } from '../services/interfaces';
import UserProfileForm from './UserProfileForm';
import { ChangePassword } from './ChangePassword';
import { ConfirmDialog } from './ConfirmDialog';
//export class NavMenu extends Component {
interface NavMenuProps {
  toggleSearch: () => void;
}

export function NavMenu({ toggleSearch }: NavMenuProps){
  const userContext = useContext(UserContext);
  const pageContext=useContext(PageContext);
  const [userQueries, setUserQueries] = useState([]);
  const [showDeleteQueryConfirm, setShowDeleteQueryConfirm]=useState(false);
  const [selectedQuery, setSelectedQuery] = useState("")
  const [submitVisible, setSubmitVisible]=useState(false);
  const [impersonateVisible, setImpersonateVisible]=useState(false);
  const [submitTitle, setSubmitTitle]=useState("Submit");
  const [submitType,setSubmitType] =useState("SB");
  const [newAdItems, setNewAdItems] = useState<string[]>([]);
  const [showMyProfile, setShowMyProfile]= useState(false);
  const [impersonateUser, setImpersonateUser]=useState("");
  const [showChangePW,setShowChangePW]=useState(false);
  const [showImpersonateError, setShowImpersonateError]=useState(false);
  
  const toggleUserQueries=()=>{
    pageContext?.setShowMyQueries(!pageContext.showMyQueries);
  }

  const showImpersonate=()=>{
    setImpersonateVisible(true);
  }

   const hideImpersonate=()=>{
    setImpersonateVisible(false);
  }

  const openImpersonateError=()=>{
    setShowImpersonateError(true);
  }

  const closeImpersonateError=()=>{
    setShowImpersonateError(false);
  }


  const toggleNotifications=()=>{
    pageContext?.setShowNotifications(!pageContext.showNotifications);
  }

  const hideMyProfile=()=>{
    setShowMyProfile(false);
  }

  const showEditProfile=()=>{
    setShowMyProfile(true);
  }

  const setImpUser=(e:InputChangeEvent)=>{
      setImpersonateUser(e.value);
  }

  const openChangePW =()=>{
    setShowChangePW(true);
  }
  const closeChangePW =()=>{
    setShowChangePW(false);
  }

  const impersonate= async ()=>{
    var userName = impersonateUser;
    console.log(impersonateUser);
    const url = "/api/Impersonate?username="+userName;
    const response = await fetch(url,{
      headers:{
      },
      method:"GET"
    });
    console.log(response);
    if (!response.ok) {
      openImpersonateError();
      //throw new Error(`Response status: ${response.status}`);
    }else{            
      window.location.reload();
    }
  }

  const getNewAdItems=()=>{
    //console.log(pageContext?.uiFeatures);
    var newItems:string[] = [];
    if (pageContext?.uiFeatures.newAd=="true"){newItems.push("New Ad")}
    if (pageContext?.uiFeatures.specAd=="true"){newItems.push("New Spec Ad")}
    if (pageContext?.uiFeatures.osOrder=="true"){newItems.push("New Sourcing Ad")}
    if (pageContext?.uiFeatures.creatopyAI==true){newItems.push("New Spec From URL")}
    //console.log("New Ad Items");
    //console.log(newItems);
    setNewAdItems(newItems);
  }
  
  const deleteQuery=()=>{
    console.log("Delete query " + selectedQuery);
    if (selectedQuery!=""){
      deleteUserQuery(selectedQuery).then(
        ()=>getSavedQueries().then(
          data => {
            setUserQueries(data);
            setSelectedQuery("");
          }
        )
      )
    }
    hideDeleteQueryWarning();
  }

  const showDeleteQueryWarning=(queryNum:string)=>{
    console.log(queryNum);
    setSelectedQuery(queryNum);
    setShowDeleteQueryConfirm(true);
  }
  
  const hideDeleteQueryWarning=()=>{
    setShowDeleteQueryConfirm(false);
  }

  const queryCriteriaRender = (props: GridCellProps) => {
    var retval = "";
    //console.log(props.dataItem);

    if (props.dataItem.sqL_Query_1000){
      var parseCrit = JSON.parse(props.dataItem.sqL_Query_1000);
      //console.log(parseCrit);
      for (let [key, value] of Object.entries(parseCrit)) {
        if (value != null) {
            retval += key + ": " + value + "&emsp;";
        }
      }
    }
    
    return (
      <td>
       {parse(retval)};
      </td>
    );
  }

  const queryButtons = (props: GridCellProps) => {
          return (
              <td>
                  <ButtonGroup>
                    <Button fillMode={"flat"}><FontAwesomeIcon icon={faShare}></FontAwesomeIcon></Button>
                    <Button fillMode={"flat"} onClick={() => showDeleteQueryWarning(props.dataItem.query_Num)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></Button>
                    {/* <Button fillMode={"flat"}><FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon></Button>                   */}
                  </ButtonGroup>
              </td>
          );
      }
  
  const handButtonClick = (event: any) => {
    //console.log('Item Clicked', event.item);
    switch (event.item){
      case "Log Out":
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace(window.location.origin + "/Login");
        break;
      case "My Queries":
        getSavedQueries().then(data => {
          setUserQueries(data);
          pageContext?.setShowMyQueries(true);
        });
        break;
      case "New Ad":
        setSubmitType("NO");
        setSubmitTitle("New Ad Order");
        setSubmitVisible(true);
        break;
      case "New Spec Ad":
        setSubmitType("SP");
        setSubmitTitle("New Spec Ad Order");
        setSubmitVisible(true);
          break;
      case "New Spec From URL":
        setSubmitType("AI");
        setSubmitTitle("New Spec Ad Order");
        setSubmitVisible(true);
          break;
      case "New Sourcing Ad":
        setSubmitType("OS");
        setSubmitTitle("New Sourcing Order");
        setSubmitVisible(true);
        break;   
      case "Edit Profile":
        setShowMyProfile(true);
        break;
      case "Reset Password":
        openChangePW();
        break;
      case "Manage Users":
        window.location.href="/admin/users"
        break;
      case "Configure AdTracker":
        window.location.href="/Admin";
        break;
      case "Impersonate User":
        showImpersonate();
        break;
      case "Clear Cache":
        clearCache();
        break;    
    }
  }

  const clearCache=()=>{
    const link = "https://dpsclearcache.com/ATOLv8.html";
    window.open(link);
  }
  const openHelp=()=>{
    const helpLink = pageContext?.glSettings.HelpLink;
    window.open(helpLink);
  }
  const openWhatsNew=()=>{
    const newLink = pageContext?.glSettings.WhatsNewLink;
    window.open(newLink);
  }
  const updateSearchFields=(fields:SearchFields)=>{
    //console.log(fields);
    const searchFields = JSON.stringify(fields);
    pageContext?.setPage({...pageContext.page,fields: searchFields || ''});
  }

  const updateFromGetNext=(element:string)=>{
    //console.log(fields);
    pageContext?.setPage({...pageContext.page,fromGetNext: element || ''});
  }

  const getNext= async ()=>{
    const nextAd = await getNextAd();
    console.log("GetNext Returned: " + nextAd);
    if (nextAd !== undefined && nextAd !== "error"){
      const fields:SearchFields={
        archive:false,
        proofOnly:false,
        omitSpec:false,
        omitNewAd:false,
        adNum:nextAd,
        status: [],
        statusMatch:"1",
        customer:{customer:"",fileSize2:"",file1:""},
        account:"",
        salesRep:[],
        color:"Select color",
        adType:"Ad type",
        section:[],
        team:[],
        size:"",
        colType:[],
        site:[],
        publication:[],
        whiteGlove:{text:"White Glove", value:""},
        tagline:"",
        dateType:{ text: "Any run date", value: "0" },
        fixedDate:{text: "Select date", value: "" },
        fixedDay:"",
        startDay:{text: "Start Day", value: "" },
        endDay:{text: "End Day", value: "" },
        startDate:"",
        endDate:"",
        allGroup:false,
        groupName:"",
        queryName:"",
        queryIsGlobal:false,
        savedQueries:"",
        issue:""
      };
      updateSearchFields(fields);
      updateFromGetNext(nextAd);
      pageContext?.setSelectedTab(5);        
    }
  }

  const getUserProfile=()=>{
    console.log(userContext?.user);
    var trusted=0;
    if (userContext?.user.trusted){
      trusted=1;
    }
    const myProfile:atolUser = {
      fullName:userContext?.user.fullName||"",
      customer:userContext?.user.customer||"",
      email:userContext?.user.email||"",
      phone:userContext?.user.phone||"",
      fax:userContext?.user.fax||"",
      userName:userContext?.user.username||"",
      password:"",
      rep_id:0,
      security:userContext?.user.type||0,
      temp1:"",
      temp2:"",
      temp3:"",
      temp4:"",
      temp5:"",
      temp6:"",
      temp7:"",
      salt:0,
      apiKey:"",
      proof_email:false,
      insert_email:false,
      submit_email:false,
      correction_email:false,
      approval_email:false,
      associations:"",
      trusted:trusted,
      superUser:false
    };
    return myProfile;
  }

  const getAdminItems=()=>{
    var userType:number = userContext?.user.type||0;
    //console.log(userType);
    if (userType==1 || userType==2){
        if (pageContext?.uiFeatures.manageUsers==true){
          return (
            <DropDownButton text="Admin"
              iconClass='fa fa-gear'
              items={["Manage Users"]}
              fillMode={'flat'}
              onItemClick={handButtonClick}
            />
          );
        }else{
          return null;
        }
    }
    if (userType==4){
        if (pageContext?.uiFeatures.manageUsers==true){
          if (userContext?.user.trafficUser==false){
            return (
              <DropDownButton text="Admin"
                iconClass='fa fa-gear'
                items={["Manage Users"]}
                fillMode={'flat'}
                onItemClick={handButtonClick}
              />
            );
          }
        }else{
          return null;
        }
    }
    if (userType==5){
      if (userContext?.user.superUser === true){
        return (
          <DropDownButton text="Admin"
            iconClass='fa fa-gear'
            items={["Manage Users","Configure AdTracker","Impersonate User"]}
            fillMode={'flat'}
            onItemClick={handButtonClick}
          />
        )
      }else{
        return (
          <DropDownButton text="Admin"
            iconClass='fa fa-gear'
            items={["Manage Users"]}
            fillMode={'flat'}
            onItemClick={handButtonClick}
          />
        )
      }
    }
  }

  const hideSubmit=()=>{
    setSubmitVisible(false);
  }

  useEffect(() => {
    getNewAdItems();
  }, [userContext?.user]);

  useEffect(()=>{
    getNewAdItems();
  },[pageContext?.uiFeatures])

  useEffect(()=>{
    if (impersonateUser!==""){
       const handleKeyPress=(event: { key: string; })=>{
                if (event.key==="Enter"){
                    impersonate();
                }
            }
            document.addEventListener('keydown',handleKeyPress);
    }
  },[impersonateUser])

  const notificationCount=useRef(0);
  
  useEffect(()=>{

    if (pageContext?.notifications && pageContext.notifications.length>0){
      const unread = pageContext.notifications.filter((item) => Number(item.state) === 0).length;
      notificationCount.current=unread;
    }

  },[pageContext?.notifications])

  return(
    <header>
      <AppBar>
        <AppBarSection>
          <img src={pageContext?.logoPath||"/img/designIQ_logo_OneClr_RGB_blue_padding.png"} alt='DPS AdTracker:Online'/>
          {/* <img src="/img/designIQ_logo_OneClr_RGB_blue_padding.png"  alt='DPS AdTracker:Online' />  */}
          {userContext?.user.type==40||userContext?.user.type==41?
          <h3>DPS MediaMagic</h3>
          :null}
        </AppBarSection>
        <AppBarSpacer style={{ width: 50 }}/>
        {userContext?.user.loggedIn?
          <>
          {userContext.user.type!=40 && userContext.user.type!=41?
          <>
          <AppBarSection>
            <Button fillMode={"flat"} type="button" onClick={toggleSearch}>
                <FontAwesomeIcon icon={faMagnifyingGlass}></FontAwesomeIcon>&nbsp;Search
            </Button>
            {pageContext?.uiFeatures.getNext==true?
            <Button fillMode={"flat"} type="button" onClick={getNext}>
                <FontAwesomeIcon icon={faForward}></FontAwesomeIcon>&nbsp;Get Next
            </Button>
            :<></>}
            <DropDownButton text="New Ad"
              iconClass='fa fa-plus'
              items={newAdItems}
              fillMode={'flat'}
              onItemClick={handButtonClick}
            />
            {getAdminItems()}
          </AppBarSection>
          <AppBarSpacer/>
          </>
          :null}
          <AppBarSection>
            <Tooltip anchorElement='Button'>
              <Button fillMode='flat' type="button" onClick={toggleNotifications} title='Notifications'>
                  <FontAwesomeIcon icon={faBell}></FontAwesomeIcon>
                  {notificationCount.current>0?
                    <BadgeContainer>
                      <Badge
                        className='navBadge'
                        rounded="full"
                        themeColor='info'
                        size='small'
                        position='inside'
                      >{notificationCount.current}</Badge>
                    </BadgeContainer>
                  :null}
                </Button>
                <Button fillMode={"flat"} type="button" onClick={openHelp} title='ATOL Documentation'>
                  <FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>
                </Button>
                <Button fillMode={"flat"} type="button" onClick={openWhatsNew} title="What's New">
                  <FontAwesomeIcon icon={faBullhorn}></FontAwesomeIcon>
                </Button>
              </Tooltip>
          </AppBarSection>
          <span className='k-appbar-separator' />
          
          <AppBarSection>
            <DropDownButton fillMode={"flat"}
              text={userContext.user.username}
              items={[userContext.user.username, "My Queries", "Edit Profile", "Reset Password","Clear Cache", "Log Out"]}
              iconClass='fa fa-user'
              onItemClick={handButtonClick}
            >
            </DropDownButton>
          </AppBarSection>
          </>
        :null}
      </AppBar>
      {pageContext?.showMyQueries?
        <Dialog
          title={"My Saved Queries"}
          onClose={toggleUserQueries}
          width={"50%"}
        >
          <Grid
            data={userQueries}
            style={{maxHeight:"400px"}}
            fixedScroll={true}
          >
            <Column
              field='query_Num'
              title='&nbsp;'
              cells={{data:queryButtons}}
              width={125}
            />
            <Column 
              field='query_Name'
              title='Query name'
            />
            <Column 
              field='sqL_Query_1000'
              title='Criteria'
              cells={{data:queryCriteriaRender}}
            />      
          </Grid>
        </Dialog>
      :null}
      {showDeleteQueryConfirm? <ConfirmDialog type='WARN' title='Delete Query' message='Are you sure you want to delete this saved query? This action can not be undone.' confirmButtonText='Yes' cancelButtonText='No' onClose={hideDeleteQueryWarning} onConfirm={deleteQuery}></ConfirmDialog>:null}
      {submitVisible && <SubmissionContextProvider><SubmissionForm title={submitTitle} type={submitType} onClose={hideSubmit}></SubmissionForm></SubmissionContextProvider>}
      {showMyProfile && <UserProfileForm title={"Edit Profile: " + userContext?.user.username} hideContactInfo={hideMyProfile} userProfile={getUserProfile()} type={"MyProfile"} action='Edit'></UserProfileForm>}
      {impersonateVisible? 
        <Dialog title={"Enter the username to impersonate"} onClose={hideImpersonate}>
          {showImpersonateError?<Notification type={{style:"error", icon:true}} onClose={closeImpersonateError}>Error: Invalid user name</Notification>:null}
          <Input onChange={setImpUser}></Input>
          <DialogActionsBar>
              <Button themeColor={"secondary"}onClick={hideImpersonate}>Cancel</Button>
              <Button themeColor={"primary"} onClick={impersonate}>Ok</Button>
          </DialogActionsBar>
        </Dialog>:null}
      {showChangePW?<ChangePassword onClose={closeChangePW} username={userContext?.user.username ?? ""}></ChangePassword>:null}
    
    </header>
  
    
  );
}
